<template lang="pug">
div
    b-container(fluid='')
        //- b-row
        //-     b-col
        //-         div.form-group.row
        //-             label(class="col-md-2" for="selectViewMode") Select view:
        //-             select(class="form-control col-md-2" id="selectViewMode"
        //-                 v-model="selectedViewMode"
        //-                 @change="onSelectViewModeChange($event)")
        //-                 option(value="peptide") Peptides
        //-                 option(value="modification") Modifications
        //-                 option(value="project") Projects
        b-row(v-if="selectedViewMode == 'peptide'")
            .bg(v-bind:class="{ 'bg-visible' : showSlide }")
            b-col(md='8' sm='12')
                p Showing {{ peptides.length }}
                b-table(hover='' 
                    v-if='peptides.length !== 0'
                    :items='peptides' :fields='peptidesFields'
                    :select-mode='selectMode'
                    ref="peptidesTable"
                    selectable
                    sort-icon-left
                    responsive table-class="w-auto"
                    @row-selected="onRowSelected")
            
        b-row(v-if="selectedViewMode == 'modification'")
            b-col(sm='8' md='12')
            
    .slide-section.pt-1(
        v-bind:class="{ open: showSlide }")
        .close-btn(@click="onCloseSlide")
        b-container(fluid='')
            b-row.mb-2.mt-5
                b-col.mt-3(sm='3' md='4')
                    b-form-group
                        b-input-group(size='sm')
                            b-form-input#filter-input(v-model='filter' type='search' placeholder='Type to Search')
                            b-input-group-append
                                b-button(:disabled='!filter' @click="filter = ''") Clear
            b-row
                b-col(md='12' sm='12' v-if="peptideModifications.length !== 0")
                    p Showing {{ peptideModifications.length }}
                    b-table(
                        :items='peptideModifications'
                        :fields='peptideModificationsFields'
                        :filter='filter'
                        fixed
                        sort-icon-left
                        )
                        template(#cell(projectId)="data")
                            a(:href="'https://proteomecentral.proteomexchange.org/cgi/GetDataset?ID=' + data.value" target="_blank") {{ data.value }}


</template>

<script>
import axios from 'axios'
const apiBaseUrl = '/scop3ptm/api/'
export default {
    name: 'Peptides',
    data() {
        return {
            peptides: [],
            projects: [],
            modifications: [],
            filter: '',
            peptideModifications: [],
            peptidesFields: [
                {key: 'sequence', sortable: true},
                {
                    key: 'sequenceLength',
                    label: 'Peptide length',
                    formatter: (value, key, item) => {
                        return item.sequence.length
                    },
                    sortable: true,
                    sortByFormatted: true
                },
                {key: 'peptideStart'},
                {key: 'peptideEnd'},
                {
                    key: 'distinctModPositions',
                    label: '# modified residues',
                    formatter: value => {
                        return value.length
                    },
                    sortable: true
                }
            ],
            peptideModificationsFields: [
                {
                    key: 'modificationType',
                    label: 'Modification type',
                    thStyle: { width: "20%" },
                    sortable: true,
                },
                {   key: 'unimodModificationName',
                    label: 'Modification name',
                    thStyle: { width: "15%" },
                    sortable: true,
                },
                {
                    key: 'peptideModificationPosition',
                    label: 'Modification position',
                    thStyle: { width: "10%" }
                },
                {
                    key: 'uniprotPosition',
                    label: 'UP position',
                    thStyle: { width: "5%" },
                    sortable: true,
                },
                {
                    key: 'peptidoformFrequency',
                    label: 'Peptidoform frequency',
                    thStyle: { width: "10%" },
                    sortable: true,
                },
                {
                    key: 'projectId',
                    thStyle: { width: "10%" },
                    sortable: true,
                },
                {
                    key: 'disease',
                    thStyle: { width: "15%" },
                    sortable: true,
                },
                {
                    key: 'tissue',
                    thStyle: { width: "10%" },
                    sortable: true,
                }
            ],
            selectMode: 'single',
            selectedRow: [],
            selectedViewMode: 'peptide',
            showSlide: false
        }
    },
    beforeMount: function() {
        if (this.$store.state.proteinId == null) {
            this.getProtein()
        }
        this.getPeptides()
    },
    methods: {
        async getPeptides() {
            const apiPeptides =  apiBaseUrl + 'get-peptides'
            const response = await axios
                .get(apiPeptides, {
                    params: {
                        proteinId: this.$store.state.proteinId
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.peptides = response.data.peptides
        },
        async getProjects() {
            const apiProjects =  apiBaseUrl + 'get-projects'
            const response = await axios
                .get(apiProjects, {
                    params: { protein: this.$store.state.proteinId }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.projects = response.data.projects
        },
        async getPeptideModifications(peptideId) {
            const apiProjects =  apiBaseUrl + 'get-peptide-modifications'
            const response = await axios
                .get(apiProjects, {
                    params: {
                        protein_id: this.$store.state.proteinId,
                        peptide_id: peptideId
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            console.log(response.data)
            this.peptideModifications = response.data.peptideModifications
        },
        async getModifications() {
            const apiProjects =  apiBaseUrl + 'get-modifications'
            const response = await axios
                .get(apiProjects, {
                    params: {
                        proteinId: this.$store.state.proteinId,
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.modifications = response.data.modifications
        },
        // move to a service
        async getProtein() {
            const apiBaseUrl = '/scop3ptm/api/protein'
            const response = await axios
                .get(apiBaseUrl, {
                    params: { protein: this.$route.params.protein }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                });
            this.$store.commit('setProteinId', response.data.proteins[0].id)
        },
        onRowSelected(items) {
            // this.selectedRow = items
            console.log(items)
            console.log(this.$store)
            this.getPeptideModifications(items[0].id)
            this.showSlide = true
        },
        clearSelected() {
            this.$refs.peptidesTable.clearSelected()
        },
        onCloseSlide() {
            this.clearSelected()
            this.showSlide = false
            this.selectedRow = []
            
        },
        onSelectViewModeChange(event) {
            this.selectViewMode = event.target.value;
        }
    }
}
</script>


<style lang="scss">
.peptideModificationsTable {
    background-color: rgba( 0,0,0, 0.075);
}
.slide-section {
    position: fixed;
    top: 50px;
    right: 0;
    height: 100%;
    width: 70%;
    background-color: #ececec;
    // visibility: hidden;
    z-index: 10;
    transform: translateX(102%);
    transition: transform 0.35s ease;
    &.open {
        overflow: auto;
        transform: translateX(0rem)
    }
    .close-btn {
        position: absolute;
        left: 15px;
        top: 15px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
        &:hover {
            opacity: 1;
        }
        &::before, &::after {
            position: absolute;
            left: 15px;
            content: ' ';
            height: 33px;
            width: 2px;
            background-color: #333;
        }
        &::before {
            transform: rotate(45deg);
        }
        &::after {
            transform: rotate(-45deg);
        }
    }
}
.bg {
    position: absolute;
    top: 100px;
    right: 0;
    width: 100%;
    height: max-content; // 100%;//calc(100% - 100px);
    visibility: hidden;
    opacity: 0;
    transition: .3s;
    background: #000;
    // filter: blur(2px);
    &.bg-visible {
        visibility: visible;
        opacity: 0.3;
    }
}
.blur {
    filter: blur(2px);
}
</style>